module.exports = __webpack_public_path__ + "img/product2.8f39f471.png";